export default "__VITE_ASSET__eec26c26__"